if (!customElements.get('l-our-brands')) {
	class LTAOurBrands extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			// Elements
			this.brandsEl = this.querySelector('[data-brands]')
			this.alphabetEls = this.querySelectorAll('[data-slide]')

			// Add click event to [data-slide] elements
			if (this.brandsEl) {
				this.addEventListener('click', (event) => {
					const slideEl = event.target.closest('[data-slide]')

					if (!slideEl) return

					// Remove active class from all alphabetEls
					this.alphabetEls.forEach((alphabetEl) => {
						alphabetEl.querySelector('[data-label]').classList.remove('is-active')
					})

					// Add active class to slideEl
					slideEl.querySelector('[data-label]').classList.add('is-active')

					// Insert template content to brandsEl
					const templateEl = slideEl.querySelector('template')
					const templateContent = templateEl.content.cloneNode(true)

					if (templateContent) {
						this.brandsEl.innerHTML = ''
						this.brandsEl.appendChild(templateContent)
					}
				})
			}
		}
	}

	customElements.define('l-our-brands', LTAOurBrands)
}

